import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Stat, { IStatProps } from '../Stat';

export interface ICompanyStat {
	/**
	 * Company Stat Image  - Image should be 240px X 250px
	 */
	image?: IImage;
	/**
	 * Company Stat
	 */
	stat?: IStatProps;
}
export interface ICompanyStatsProps extends IBaseElementProps {
	companyStats: ICompanyStat[];
}

/**
 * Company Stats
 * @block
 * @requiresHooks
 * @icon editor-ol-rtl
 */
const CompanyStats: React.FC<ICompanyStatsProps> = ({
	className,
	classNames = [],
	companyStats = [],
}) => (
	<div className={className || cn('company-stats', ...classNames)}>
		<div className="company-stats__container container">
			{!companyStats.length ? null : (
				<div className="row">
					{companyStats.map((companyStat, index) => (
						<div
							key={index}
							className="company-stats__item col-12 col-md-4"
						>
							<div className="company-stats__item-image">
								<Image
									className="img-fluid"
									{...companyStat.image}
								/>
							</div>
							<div className="company-stats__item-stats">
								<Stat {...companyStat.stat} />
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	</div>
);

export default CompanyStats;
